import {
  FETCH_PATIENT_QUEUE_REQUEST,
  FETCH_PATIENT_QUEUE_SUCCESS,
  FETCH_PATIENT_QUEUE_FAILURE,
  SET_SELECTED_PATIENT,
  PROCESS_PAYMENT_REQUEST,
  PROCESS_PAYMENT_SUCCESS,
  PROCESS_PAYMENT_FAILURE,
} from "../types/CounsellorTypes";
import axiosInstance from "../../services/AxiosInstance";
import {
  getPatientQueue,
  collectPayment,
} from "../../services/ReceptionistService";

// Patient Queue Actions
export const fetchPatientQueueRequest = () => ({
  type: FETCH_PATIENT_QUEUE_REQUEST,
});

export const fetchPatientQueueSuccess = (data) => ({
  type: FETCH_PATIENT_QUEUE_SUCCESS,
  payload: data,
});

export const fetchPatientQueueFailure = (error) => ({
  type: FETCH_PATIENT_QUEUE_FAILURE,
  payload: error,
});

export const setSelectedPatient = (patient) => ({
  type: SET_SELECTED_PATIENT,
  payload: patient,
});

// Payment Actions
export const processPaymentRequest = () => ({
  type: PROCESS_PAYMENT_REQUEST,
});

export const processPaymentSuccess = (data) => ({
  type: PROCESS_PAYMENT_SUCCESS,
  payload: data,
});

export const processPaymentFailure = (error) => ({
  type: PROCESS_PAYMENT_FAILURE,
  payload: error,
});

// Thunk Actions
export const fetchPatientQueue = () => {
  return async (dispatch) => {
    dispatch(fetchPatientQueueRequest());
    try {
      const response = await axiosInstance.post("/admin/PatientQueueList", {
        is_counsellor: "YES",
      });
      if (response?.data?.status === "success") {
        dispatch(fetchPatientQueueSuccess(response.data.data));
      } else {
        throw new Error(
          response?.data?.message || "Failed to fetch patient queue"
        );
      }
    } catch (error) {
      dispatch(fetchPatientQueueFailure(error.message));
    }
  };
};

export const processPayment = (paymentData) => {
  return async (dispatch) => {
    dispatch(processPaymentRequest());
    try {
      const response = await collectPayment(paymentData);

      if (response?.data?.status === "success") {
        dispatch(processPaymentSuccess(response.data.data));
        // Refresh the queue after successful payment
        dispatch(fetchPatientQueue());
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Payment processing failed");
      }
    } catch (error) {
      dispatch(processPaymentFailure(error.message));
      throw error;
    }
  };
};

export const fetchPatientQueueAction = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PATIENT_QUEUE_REQUEST });

    try {
      const patients = await getPatientQueue();
      dispatch({
        type: FETCH_PATIENT_QUEUE_SUCCESS,
        payload: patients,
      });
    } catch (error) {
      dispatch({
        type: FETCH_PATIENT_QUEUE_FAILURE,
        payload: error.message,
      });
    }
  };
};
